/**
 * Image Helper Utility
 * Handles image loading with proper error handling and CORS support
 */

/**
 * Get image source with fallback handling
 * @param {string} imageUrl - The image URL
 * @returns {string} - The image URL or fallback
 */
export const getImageSrc = (imageUrl) => {
  if (!imageUrl) return null;
  
  // If it's already a data URL or blob URL, return as is
  if (imageUrl.startsWith('data:') || imageUrl.startsWith('blob:')) {
    return imageUrl;
  }
  
  // If it's a relative path, return as is
  if (imageUrl.startsWith('/')) {
    return imageUrl;
  }
  
  // For external URLs, return as is (browser will handle CORS)
  return imageUrl;
};

/**
 * Image component with error handling
 */
export const SafeImage = ({ src, alt, className, style, onError, ...props }) => {
  const handleError = (e) => {
    console.error('Image failed to load:', src);
    if (onError) {
      onError(e);
    } else {
      e.target.style.display = 'none';
    }
  };

  const imageSrc = getImageSrc(src);
  
  if (!imageSrc) {
    return null;
  }

  return (
    <img
      src={imageSrc}
      alt={alt || 'Image'}
      className={className}
      style={style}
      onError={handleError}
      referrerPolicy="no-referrer"
      loading="lazy"
      {...props}
    />
  );
};

export default SafeImage;

